import commonApiAuthRequest from "../apiAuthRequest"
import { TOIR_SERVICE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/toir/version%2F1.0/inspection-service.oas2.yml?view=%2Freference%2Fdefect%2Ffinddefectmodels
*/

export const visitsFetch = issueId =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/visit`,
    params: { query: `issueId=in=(${issueId})` },
  })

/**
 * makes request to get visits by issueId
 *
 * @param {number} issueId
 * @return {Array.<Object>} response - array of visits
 */
export const getVisits = async issueId => {
  if (!issueId) {
    return undefined
  }

  const { data: visits } = await visitsFetch(issueId)

  return visits
}
